// Comercios para los selects de usuarios y grupos. Las sucursales se muestran con su cadena
// ("Walmart › Escazú") y después de su casa matriz.

export interface OwnerMerchantOption {
    id: number;
    name: string;
    bankId?: number | null;
    parentId?: number | null;      // sucursal: casa matriz
    parentName?: string | null;
}

export const merchantOptionLabel = (merchant: OwnerMerchantOption) =>
    merchant.parentName ? `${merchant.parentName} › ${merchant.name}` : merchant.name;

const compare = (a: string, b: string) => a.localeCompare(b, 'es', { sensitivity: 'base' });

export const sortMerchantOptions = <T extends OwnerMerchantOption>(merchants: T[]): T[] =>
    [...merchants].sort((a, b) =>
        compare(a.parentName ?? a.name, b.parentName ?? b.name)
        || (a.parentId ? 1 : 0) - (b.parentId ? 1 : 0)
        || compare(a.name, b.name));
